import { ReportProfileAlertRulesComputedDelegateModel } from '../profile/report-profile-alert-rules-computed-delegate-model';

export class ZimbraReportProfileAlertRulesComputedDelegateModel extends ReportProfileAlertRulesComputedDelegateModel {
}
